// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I0fP4{display:flex;gap:24px;align-items:stretch;width:100%;height:100%}.ZunQP{display:flex;flex-direction:column;gap:20px;flex:1;min-height:0}.yNDKl{flex:1;min-height:140px}.yNDKl.ZFHEk{height:140px;flex:none}.eeaXy{flex:3;min-width:0}.q7TYS{width:100%}.zSpAs{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `I0fP4`,
	"leftColumn": `ZunQP`,
	"logoPickerWrapper": `yNDKl`,
	"logoPickerMobile": `ZFHEk`,
	"previewWrapper": `eeaXy`,
	"mobileRoot": `q7TYS`,
	"mobilePreview": `zSpAs`
};
export default ___CSS_LOADER_EXPORT___;
